<template>
  <div class="nav-vertical py-0 filterItemCheckboxContainer">
    <!-- <c-filter-item-heading
      v-if="item.heading"
      v-bind="item.heading"
      :show-chevron="showChevron"
    ></c-filter-item-heading> -->
    <fieldset>
      <legend class="nav-vertical__content px-2 ml-1 nav-vertical__item py-0 idontlooklikealink">{{ item.heading.name }}</legend>
      <div v-if="item.options" :options="item.options" :radio="item.radio">
          <span class="filterItemMessage px-1" v-if="item.message" :tabindex="item.messageTabIndex || 0">
            {{ item.message }}
          </span>
          <c-new-filter-item-checkbox-options
            v-if="item.options"
            :options="item.options"
            :radio="item.radio"
            @filter-selected="$emit('filter-selected', $event)"
          >
            <span
              class="filterItemMessage px-1"
              v-if="item.message"
              :tabindex="item.messageTabIndex || 0"
            >
            {{ item.message }}
            </span>
          </c-new-filter-item-checkbox-options>
      </div>
    </fieldset>
    <!-- <c-filter-item-checkbox-options
      v-if="item.options"
      :options="item.options"
      :radio="item.radio"
      @filter-selected="$emit('filter-selected', $event)"
    >
      <span
        class="filterItemMessage px-1"
        v-if="item.message"
        :tabindex="item.messageTabIndex || 0"
      >
        {{ item.message }}
      </span>
    </c-filter-item-checkbox-options> -->
  </div>
</template>

<script>
// import FilterItemHeading from '@/components/pages/filter/FilterItemHeading'
// import FilterItemCheckboxOptions from '@/components/pages/filter/checkbox/FilterItemCheckboxOptions.vue'
import NewFilterItemCheckboxOptions from '@/components/pages/filter/checkbox/NewFilterItemsCheckboxOptions.vue'

export default {
  components: {
    // 'c-filter-item-heading': FilterItemHeading,
    // 'c-filter-item-checkbox-options': FilterItemCheckboxOptions,
    'c-new-filter-item-checkbox-options': NewFilterItemCheckboxOptions,
  },
  props: { item: { required: true, type: Object }, showChevron: Boolean, },
}
</script>

<style lang="scss" scoped>
span.filterItemMessage:focus {
  outline: 3px solid #EA5D4E;
  // color: rgb(0, 0, 0);
  // background-color: rgb(254, 212, 122);
  // box-shadow: rgb(254 212 122) 0px -2px, rgb(33 43 50) 0px 4px;
  // outline: 0px;
}
</style>
